import { crearTabla } from '@plataforma/ui';

import { obtenerDashboardResumen } from '../api/backoffice.js';
import { exigirSuperAdmin } from '../guardas.js';

import { moneda, estadoCarga, estadoError, tarjetaMetrica } from './backoffice-ui.js';
import { montarShell } from './shell.js';

// Esta vista consume EXACTAMENTE el contrato que devuelve
// rpc_super_admin_dashboard_resumen() en su versión vigente
// (20260913000004 + fixes). No usa campos históricos que la RPC dejó de
// devolver (suscripciones.*, empresas_por_plan, ingresos.ingresos_reales_30d,
// fuentes_mrr) — antes eso volvía vacías varias tarjetas.
export async function vistaDashboard(contenedorRaiz) {
  if (!exigirSuperAdmin()) return;

  const contenido = montarShell(contenedorRaiz, '/');
  contenido.innerHTML = estadoCarga('Cargando estado del negocio...');

  const { data, error } = await obtenerDashboardResumen();

  if (error) {
    contenido.innerHTML = estadoError('No se pudo cargar el dashboard ejecutivo.');
    return;
  }

  const empresas = data?.empresas ?? {};
  const usuarios = data?.usuarios ?? {};
  const trials = data?.trials ?? {};
  const pagos = data?.pagos ?? {};
  const periodosServicio = data?.periodos_servicio ?? {};
  const comercial = data?.comercial ?? {};
  const ingresos = data?.ingresos ?? {};
  const mrrPorPlan = ingresos.mrr_por_estado ?? [];

  contenido.innerHTML = `
    <div class="pf-backoffice-header">
      <div>
        <h1>Dashboard</h1>
        <p class="pf-texto-suave">Estado ejecutivo y comercial de la plataforma.</p>
      </div>
      <a class="pf-boton pf-boton--secundario" href="#/actividad">Ver actividad</a>
    </div>

    <div class="pf-dashboard__tarjetas">
      ${tarjetaMetrica({ titulo: 'Empresas', valor: empresas.total ?? 0, subtitulo: `${empresas.activas ?? 0} activas`, tono: 'exito' })}
      ${tarjetaMetrica({ titulo: 'Usuarios', valor: usuarios.total ?? 0, subtitulo: `${usuarios.activos ?? 0} activos`, tono: 'info' })}
      ${tarjetaMetrica({ titulo: 'Periodos de servicio activos', valor: periodosServicio.activos ?? 0, subtitulo: `${periodosServicio.pendientes ?? 0} pendientes por activar`, tono: 'exito' })}
      ${tarjetaMetrica({ titulo: 'Trials por vencer', valor: trials.proximos_a_vencer ?? 0, subtitulo: `${trials.activos ?? 0} trials activos`, tono: 'alerta' })}
      ${tarjetaMetrica({ titulo: 'Contrataciones 30d', valor: comercial.contrataciones_30d ?? 0, subtitulo: `${comercial.contrataciones_pendientes ?? 0} pendientes`, tono: 'info' })}
      ${tarjetaMetrica({ titulo: 'MRR estimado', valor: moneda(ingresos.mrr_estimado), subtitulo: 'Estimado desde suscripciones activas', tono: 'alerta' })}
    </div>

    <div class="pf-backoffice-grid pf-backoffice-grid--2" style="margin-top: 20px;">
      <section class="pf-tarjeta pf-backoffice-card">
        <h2>Operación</h2>
        <div class="pf-backoffice-detail" style="margin-top: 12px;">
          <div class="pf-backoffice-kv"><span>En prueba</span><strong>${empresas.en_prueba ?? 0}</strong></div>
          <div class="pf-backoffice-kv"><span>Suspendidas</span><strong>${empresas.suspendidas ?? 0}</strong></div>
          <div class="pf-backoffice-kv"><span>Trials vencidos</span><strong>${trials.vencidos ?? 0}</strong></div>
          <div class="pf-backoffice-kv"><span>Periodos vencidos</span><strong>${periodosServicio.vencidos ?? 0}</strong></div>
        </div>
      </section>
      <section class="pf-tarjeta pf-backoffice-card">
        <h2>Ingresos</h2>
        <div class="pf-backoffice-detail" style="margin-top: 12px;">
          <div class="pf-backoffice-kv"><span>Ingresos reales 30d</span><strong>${moneda(pagos.ingresos_reales_30d)}</strong></div>
          <div class="pf-backoffice-kv"><span>MRR estimado</span><strong>${moneda(ingresos.mrr_estimado)}</strong></div>
        </div>
        <p class="pf-backoffice-note" style="margin-top: 12px;">
          Los ingresos reales salen de la tabla pago con estado pagado o aprobado. El MRR se estima desde suscripciones activas y el precio mensual del plan.
        </p>
      </section>
    </div>

    <section class="pf-tarjeta pf-backoffice-card" style="margin-top: 20px;">
      <h2>MRR por plan</h2>
      <div id="pf-mrr-plan" style="margin-top: 12px;"></div>
    </section>
  `;

  const destino = contenido.querySelector('#pf-mrr-plan');
  destino.appendChild(
    crearTabla({
      filaVacia: 'Todavía no hay suscripciones activas.',
      columnas: [
        { clave: 'plan', titulo: 'Plan' },
        { clave: 'suscripciones', titulo: 'Suscripciones' },
        {
          titulo: 'MRR',
          render: (fila) => moneda(fila.mrr),
        },
        {
          titulo: 'Distribución',
          render: (fila) => crearBarra(fila.mrr, ingresos.mrr_estimado),
        },
      ],
      filas: mrrPorPlan,
    }),
  );
}

function crearBarra(valor, total) {
  const porcentaje = total > 0 ? Math.round((Number(valor) / Number(total)) * 100) : 0;
  const contenedor = document.createElement('div');
  contenedor.className = 'pf-backoffice-bar__pista';
  contenedor.innerHTML = `<div class="pf-backoffice-bar__valor" style="width:${porcentaje}%"></div>`;
  return contenedor;
}
